import { render, staticRenderFns } from "./GlobalMetrics.vue?vue&type=template&id=d4a88a36"
import script from "./GlobalMetrics.vue?vue&type=script&lang=js"
export * from "./GlobalMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports